import dayjs from "dayjs";
import "dayjs/locale/pt-br";

dayjs.locale("pt-br");

const WEEKDAYS_PT = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SAB"];

export interface ParsedDisplayDate {
  weekday: string;
  day: string;
  month: string;
  time: string | null;
}

/** Converte DD/MM/YYYY, ISO ou Date em partes para o badge lateral */
export function parseDisplayDate(
  date?: string | null,
  time?: string | null,
): ParsedDisplayDate | null {
  if (!date || date === "-") return null;

  let parsed = dayjs(date, "DD/MM/YYYY", true);
  if (!parsed.isValid()) parsed = dayjs(date);

  if (!parsed.isValid()) return null;

  const normalizedTime = normalizeTime(time);

  return {
    weekday: WEEKDAYS_PT[parsed.day()],
    day: parsed.format("DD"),
    month: parsed.format("MMM").toUpperCase().replace(".", ""),
    time: normalizedTime,
  };
}

function normalizeTime(value?: string | null): string | null {
  if (!value) return null;

  const asDayjs = dayjs(`2000-01-01T${value}`);
  if (asDayjs.isValid()) return asDayjs.format("HH:mm");

  const loose = dayjs(value, ["HH:mm", "H:mm", "h:mm A", "hh:mm A"]);
  if (loose.isValid()) return loose.format("HH:mm");

  return value;
}

/** Extrai horário da posologia FHIR ou da data do documento */
export function extractTimeFromResource(resource?: any): string | null {
  const timeOfDay = resource?.dosageInstruction?.[0]?.timing?.repeat?.timeOfDay?.[0];
  if (timeOfDay) {
    const parsed = dayjs(`2000-01-01T${timeOfDay}`);
    if (parsed.isValid()) return parsed.format("HH:mm");
  }

  if (resource?.date) {
    const parsed = dayjs(resource.date);
    if (parsed.isValid() && (parsed.hour() !== 0 || parsed.minute() !== 0)) {
      return parsed.format("HH:mm");
    }
  }

  if (resource?.authoredOn) {
    const parsed = dayjs(resource.authoredOn);
    if (parsed.isValid()) return parsed.format("HH:mm");
  }

  return null;
}
